<div class="media-list" id="RecipesModifyClassificationAdvancedMediaLstBtn">
  <div *ngFor="let mediaVar of recipeOriginal?.resourceMedias; let index = index">
    <img [src]="mediaVar.media.thumbnail" *ngIf="mediaVar.media.type === 'PHOTO'" class="media-element" alt="cover" />
    <video *ngIf="mediaVar.media.type === 'VIDEO' && !isYoutubeVideo(mediaVar.media.original)" [controls]="false" class="media-element">
      <source [src]="mediaVar.media.original + '?fit=CROP&w=200&h=200'" type="video/mp4" />
    </video>
    <div *ngIf="mediaVar.media.type === 'VIDEO' && isYoutubeVideo(mediaVar.media.original)" style="display: inline-block">
      <div class="stop-click-video stop-click-video-small cursor-normal"></div>
      <iframe
        [src]="transformForYoutube(mediaVar.media.original) | safeUrl"
        width="200"
        height="200"
        allowfullscreen
        *ngIf="!mediaVar.media.thumbnail"
        class="media-element"
        title="youtube-video-2"
      ></iframe>
      <img
        *ngIf="mediaVar.media.thumbnail"
        [src]="mediaVar.media.thumbnail + '?fit=CROP&w=200&h=200'"
        class="media-element"
        alt="youtube-thumbnail-2"
      />
    </div>
    <mat-icon *ngIf="mediaVar.isCover" class="badge-star" mat-mini-fab>star</mat-icon>
  </div>
</div>
